var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmazy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "329.84px",
    height: "276.35px",
    viewBox: "0 0 329.84 276.35",
    enableBackground: "new 0 0 329.84 276.35",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CDDFE3",
    d: "M287.82,240.5c-44.58,49.26-86.62,27.1-150.23,21.03c-63.61-6.07-109.47,1.08-129.8-78.54 S77.76,2.05,169.05,5.44C277.91,9.49,383.56,134.72,287.82,240.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#868B90",
    d: "M245.55,210.53c-31.13,33.43-59.14,15.42-103.56,11.3s-77.78,3.71-91.97-50.32S103.58,48.69,167.33,50.99 C243.34,53.74,312.4,138.74,245.55,210.53z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 1522.4424,
    cy: 140.6509,
    r: 147.6181,
    gradientTransform: "matrix(-0.9745 -0.2246 -0.2041 0.8858 1672.6069 357.9699)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A4A9AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AAAEB2",
      stopOpacity: 0.0296
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M245.55,210.53c-31.13,33.43-59.14,15.42-103.56,11.3s-77.78,3.71-91.97-50.32 S103.58,48.69,167.33,50.99C243.34,53.74,312.4,138.74,245.55,210.53z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 1522.4424,
    cy: 140.6509,
    r: 106.6975,
    gradientTransform: "matrix(-1 -1.401890e-03 -1.143257e-03 0.8155 1682.9419 28.083)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4C8CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6534,
    style: {
      stopColor: "#C2C6CA",
      stopOpacity: 0.3466
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9682,
    style: {
      stopColor: "#BAC0C3",
      stopOpacity: 0.0318
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B9BFC2",
      stopOpacity: 0
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M245.55,210.53c-31.13,33.43-59.14,15.42-103.56,11.3s-77.78,3.71-91.97-50.32 S103.58,48.69,167.33,50.99C243.34,53.74,312.4,138.74,245.55,210.53z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 1522.4424,
    cy: 140.6509,
    r: 82.5733,
    gradientTransform: "matrix(-1 -1.401890e-03 -1.143257e-03 0.8155 1682.9419 28.083)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#DDE2E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4DFE6",
      stopOpacity: 0
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M245.55,210.53c-31.13,33.43-59.14,15.42-103.56,11.3s-77.78,3.71-91.97-50.32 S103.58,48.69,167.33,50.99C243.34,53.74,312.4,138.74,245.55,210.53z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999 -0.0437 0.0437 0.999 -5.5608 4.9365)",
    fill: "#181818",
    cx: 110.25,
    cy: 129.79,
    rx: 19.05,
    ry: 40.35
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9991 -0.0432 0.0432 0.9991 -5.4609 4.8264)",
    fill: "#1B2226",
    cx: 108.97,
    cy: 128.79,
    rx: 14.69,
    ry: 31.18
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9984 -0.0563 0.0563 0.9984 -6.8842 6.2765)",
    fill: "#2A373F",
    cx: 108.03,
    cy: 125.4,
    rx: 12.91,
    ry: 25.75
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9986 -0.0524 0.0524 0.9986 -6.5025 11.0128)",
    fill: "#181818",
    cx: 206.61,
    cy: 129.42,
    rx: 18.82,
    ry: 39.26
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.999 -0.044 0.044 0.999 -5.4302 9.1482)",
    fill: "#1B2226",
    cx: 205.25,
    cy: 128.02,
    rx: 14.06,
    ry: 31.28
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9997 -0.0231 0.0231 0.9997 -2.816 4.7251)",
    fill: "#2A373F",
    cx: 203.01,
    cy: 124.19,
    rx: 11.27,
    ry: 23.32
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9939 -0.1106 0.1106 0.9939 -12.4481 12.0491)",
    fill: "#FFC61B",
    cx: 102.38,
    cy: 118.23,
    rx: 5.97,
    ry: 8.6
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9973 -0.0734 0.0734 0.9973 -9.9463 8.9703)",
    fill: "#FFC61B",
    cx: 117.04,
    cy: 139.77,
    rx: 3.81,
    ry: 5.15
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9951 -0.0991 0.0991 0.9951 -10.7267 20.0758)",
    fill: "#FFC61B",
    cx: 196.73,
    cy: 118.02,
    rx: 5,
    ry: 7.02
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9985 -0.0542 0.0542 0.9985 -7.3054 11.5874)",
    fill: "#FFC61B",
    cx: 209.8,
    cy: 140.37,
    rx: 2.86,
    ry: 3.73
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1515.0221,
    y1: 192.4351,
    x2: 1518.6753,
    y2: 131.6776,
    gradientTransform: "matrix(-0.9997 0.0231 0.0231 0.9997 1672.9633 -19.0903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#404749"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    style: {
      stopColor: "#313537"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181818"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M167.34,156.59l-17.19-0.5c-1.38,0.03-2.43,0.53-2.1,5.63c1,15.46,5.29,45.84,14.06,45.64 s7.29-29.76,7.58-45.25C169.79,157.01,168.71,156.56,167.34,156.59z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazy);
export default __webpack_public_path__ + "static/media/amazy.6516afb04189ece1ef60763c2decfaa3.svg";
export { ForwardRef as ReactComponent };